import { ODSDropdownSelectMenuItemProps } from "./ODSDropdownSelect.types";

export {
  getIndexFromValueOrLabel,
  generateTypeheadList,
  getSelectedLabel,
  getSelectedLabelText,
  getLabel,
  getKeyIndex,
};

function getKeyIndex(
  items: ODSDropdownSelectMenuItemProps[],
  value?: string
): number | null {
  if (!value) return -1;
  const item = items.find(
    (item) => item.labelText === value || item.value === value
  );
  const index = item ? items.indexOf(item) : -1;
  return index;
}

function getIndexFromValueOrLabel(
  items: ODSDropdownSelectMenuItemProps[],
  value?: string
): number | null {
  if (!value) return null;
  const item = items.find(
    (item) => item.labelText === value || item.value === value
  );
  if (item?.disabled) {
    return null;
  }
  const index = item ? items.indexOf(item) : -1;
  return index === -1 ? null : index;
}

function generateTypeheadList(
  items: ODSDropdownSelectMenuItemProps[]
): (string | null)[] {
  if (!items?.length) return [];
  return items.map((item) => (item.disabled ? null : item.labelText));
}

function getSelectedLabel(
  items: ODSDropdownSelectMenuItemProps[],
  label: string,
  selectedIndex: number | null
): string {
  if (selectedIndex === null) return label;
  return items[selectedIndex].labelText;
}

function getSelectedLabelText(
  items: ODSDropdownSelectMenuItemProps[],
  selectedIndex: number | null
): string {
  if (selectedIndex === null) return "";
  return items[selectedIndex].labelText;
}

function getLabel(label: string, isRequired: boolean): string {
  if (isRequired) return `${label} *`;
  return label;
}
